import React from "react";

function MobileHeader({ setMenu, menu }) {
  return (
    <div
      className="mobile__header__menu"
      style={menu ? { left: 0 } : { left: "-200px" }}
    >
      <p onClick={() => setMenu(false)} className="hide__btn">
        <i className="fa fa-arrow-circle-left" style={{ color: "white" }}></i>
      </p>
      <div>
        <a rel="noreferrer noopener">Home</a>
      </div>
      <div>
        <a
          rel="noreferrer noopener"
          target="_blank"
          href="https://finblue.stpi.in/incubator-program/apply-for-incubator-program/"
        >
          Pitchfest
        </a>
      </div>
      <div>
        <a
          rel="noreferrer noopener"
          target="_blank"
          href="https://finblue.stpi.in/incubator-program/fintech-incubator-program/"
        >
          The Program
        </a>
      </div>
      <div>
        <a
          rel="noreferrer noopener"
          target="_blank"
          href="https://finblue.stpi.in/sandbox-api/"
        >
          Sandbox API
        </a>
      </div>
      <div>
        <a rel="noreferrer noopener">Marketplace</a>
      </div>
      <div>
        {" "}
        <a rel="noreferrer noopener">List your Startup</a>
      </div>
      <div className="divider"></div>
      <div>
        <a
          rel="noreferrer noopener"
          target="_blank"
          href="https://finblue.stpi.in/incubator-program/about-finblue-incubator-program/#about-STPI"
        >
          About Us
        </a>
      </div>
      <div>
        <a rel="noreferrer noopener">Contact us</a>
      </div>
      <div>
        <a rel="noreferrer noopener">Privacy</a>
      </div>
      <div>
        <a rel="noreferrer noopener">Login</a>
      </div>
    </div>
  );
}

export default MobileHeader;
